<template>
  <div class="Meet">

    <div class="Meet-container">

      <div class="Meet-header">

        <p class="Meet-title t-headingMd">Meet {{ this.animal.name }}!</p>

        <p class="Meet-subtitle">
          A PetSpace representatitve is available to help you connect.<br> Just follow the path below to our PetConnect center.
        </p>

      </div>

      <div class="Meet-map">

        <img class="Meet-mapImage" :src="image">

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Meet',

  created () {
    this.$nextTick(() => {
      this.$store.dispatch('showCircleBorder', true)
    })
  },

  mounted () {
    // Wait a little for the analytics start event to dispatch
    setTimeout(() => {
      this.$analytics.event(`Meet/Page1`)
    }, 100)
  },

  beforeDestroy () {
    this.$store.dispatch('showCircleBorder', false)
  },

  computed: {
    animal () { return this.$store.state.animal },
    suite () { return this.$store.state.suite },
    suiteColors () { return this.$store.state.settings.suiteColors },

    image () {
      if (!this.animal.species) return
      return `static/images/maps/suite_${this.suite.suiteNumber}_${this.suiteColors[this.suite.suiteNumber]}.png`
    }
  }
}
</script>

<style>
.Meet {

}

.Meet-header {
  position: absolute;
  top: 200px;
  width: 100%;
  text-align: center;
}

.Meet-title {
  color: var(--color-5);
}

.Meet-subtitle {
  margin-top: 18px;
  font-size: 17px;
  line-height: 24px;
  font-weight: 500;
}

.Meet-map {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.Meet-mapImage {
  display: block;
}
</style>



// WEBPACK FOOTER //
// Meet.vue?439bc489